import React from 'react'
import styled from 'styled-components';
import {colors, mediaQueries, fonts} from "../shared/config"

function InfluentialSneakerHeader() {
    return (
        <Background>
            <Container>
                <LargeSubheader>Good for the outsole</LargeSubheader>
                <SmallSubheader>The most meaningful and influential sneakers</SmallSubheader>
            </Container>
        </Background>
    )
}

const Background = styled.div`
    background-color: #A32929;
    padding: 4em 0;
`

const Container = styled.div`
    width: 65%;
    margin: auto;
    ${mediaQueries.mobile} {
        width: 75%;
        margin: auto;
    }
`

const Header = styled.div`
    margin: 0;
    color: white;
    text-align: left;
    text-transform: uppercase;
    font-family: ${fonts.header};
    font-style: normal;
    font-weight: normal;
    line-height: 75%;
`

const LargeSubheader = styled(Header)`
    text-align: left;
    font-size: 96px;
    ${mediaQueries.mobile} {
        font-size: 36px;
        margin-bottom: 0.5em;
    }
`

const SmallSubheader = styled(Header)`
    text-align: right;
    font-size: 48px;
    ${mediaQueries.mobile} {
        font-size: 24px;
    }
`

export default InfluentialSneakerHeader

